/* eslint-disable no-underscore-dangle */
import { toast } from "react-toastify";
import React from "react";

import { AutoForm, AutoField, ErrorsField } from "uniforms-semantic";
import { Grid, Button } from "semantic-ui-react";

import { PasswordSchema, PLACEHOLDER_TEXT } from "./password.schema";
import { ToastWrapper } from "../../components/wrapper/Toastwrapper";

import resetPasswordMutate from "./utils/resetPasswordMutate";
import useRoute from "../../router/useRoute";
import { initJSONschema } from "/imports/utils/UI/initJSONschema";

import Debug from "debug";
const debug = Debug("routes:password");

let formRef;

const PasswordForm = ({ token }) => {
  const { goRoute } = useRoute();

  debug("PasswordForm called");

  const handleFormSubmit = async ({ password }) => {
    if (token) {
      debug("result pasword reset");

      try {
        await resetPasswordMutate({
          token,
          password
        });

        toast.info("Password changed!");
        return goRoute("signIn");
      } catch (err) {
        return toast.error(
          <ToastWrapper>
            <b>Unable to reset password!</b>
            <br />
            {err.reason}
          </ToastWrapper>
        );
      }
    }
  };

  return (
    <AutoForm
      schema={initJSONschema(PasswordSchema)}
      onValidate={async (model, error) => {
        if (model.password !== model.p2) return { 
          details: [
            ...(error ? error.details : []), 
            { keyword: 'passWordShouldMatchError', message: "Passwords don't match" }] }
        // You can either ignore validation error...
        return error
      }}
      onSubmit={handleFormSubmit}
      ref={ref => {
        formRef = ref;
      }}
    >
      <img className="ui medium image logo" src="/images/logo-transmate.svg" alt="logo" />

      <AutoField
        name="password"
        label="Password"
        placeholder={PLACEHOLDER_TEXT}
        autoComplete="new-password"
      />
      <AutoField
        name="p2"
        label="Repeat password"
        placeholder={PLACEHOLDER_TEXT}
        autoComplete="new-password"
      />
      <Grid columns={2}>
        <Grid.Column>
          <Button primary type="button" content="Set password" onClick={() => formRef.submit()} />
        </Grid.Column>
        <Grid.Column>
          <a href="" onClick={() => goRoute("signIn")}>
            Or sign in
          </a>
        </Grid.Column>
      </Grid>
      <ErrorsField />
    </AutoForm>
  );
};

export default PasswordForm;
